export default function percentage(n) {
  let precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let number;
  if (n === Infinity) {
    number = "∞";
  } else if (n === -Infinity) {
    number = "-∞";
  } else {
    number = (Number(n) * 100).toFixed(precision);
  }
  return number + "%";
}